import React, { useState, useEffect } from "react";
import "./style.css";
import RequestItem from "../../components/RequestItem";
import CreateServiceRequestRow from "../../components/CreateServiceRequestRow";
import API from "../../utils/API";

function ServiceRequestController({ adminUserID }) {
  const [formData, setFormData] = useState({
    requests: [],
    refreshRequests: [],
    clients: [],
    agents: [],
    searchTerm: "",
    showCreateServiceRequestRow: false
  });

  useEffect(() => {
    console.log("Service Request Tracker Card Mounted");
    API.getServicerequests().then((res) => {
      console.log("Retrieved Service Requests");
      console.log(res.data);
      setFormData((prev) => ({ ...prev, requests: res.data }));
    });
    API.getClients().then((res) => {
      setFormData((prev) => ({ ...prev, clients: res.data }));
      console.log(res);
    });
    API.getAgents().then((res) => {
      setFormData((prev) => ({ ...prev, agents: res.data }));
      console.log(res);
    });
  }, []);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const completeAndRemove = () => {
    API.getServicerequests().then((res) => {
      console.log("Retrieved Service Requests");
      console.log(res.data);
      setFormData((prev) => ({
        ...prev,
        requests: res.data,
        refreshRequests: res.data
      }));
    });
  };

  const resetTable = () => {
    console.log("Resetting table");
    console.log("Transforming policies table: ");
    console.table(formData.requests);
    console.log("Into original table: ");
    console.table(formData.refreshRequests);
    setFormData((prev) => ({
      ...prev,
      requests: [],
      showCreateServiceRequestRow: false
    }));
    API.getServicerequests().then((res) => {
      console.log("Retrieved Service Requests");
      console.log(res.data);
      setFormData((prev) => ({
        ...prev,
        requests: res.data,
        refreshRequests: res.data
      }));
    });
  };

  const searchTable = (e) => {
    e.preventDefault();
    console.log("Search Table for: " + formData.searchTerm);
    const rowsWithTerm = [];
    for (let i = 0; i < formData.refreshRequests.length; i++) {
      const object = formData.refreshRequests[i];

      for (const property in object) {
        console.log(`${property}: ${object[property]}`);
        console.log(typeof property);
        console.log(typeof object[property]);
        if (typeof object[property] === "string") {
          if (object[property].toLowerCase().indexOf(formData.searchTerm.toLowerCase()) > -1) {
            if (rowsWithTerm.length === 0) {
              rowsWithTerm.push(object);
            } else {
              let rowFoundAlready = false;
              for (let j = 0; j < rowsWithTerm.length; j++) {
                if (rowsWithTerm[j]._id === object._id) {
                  rowFoundAlready = true;
                }
                if (j === rowsWithTerm.length - 1) {
                  if (rowFoundAlready === false) {
                    rowsWithTerm.push(object);
                  }
                }
              }
              setFormData((prev) => ({
                ...prev,
                requests: rowsWithTerm
              }));
            }
          }
        }
      }

      if (i === formData.refreshRequests.length - 1) {
        console.log("Completed search");
        console.log("Rows with Term: " + formData.searchTerm);
        console.log(rowsWithTerm);
        console.table(rowsWithTerm);
      }
    }
  };

  const toggleCreateServiceRequestRow = (e) => {
    console.log("Showing Create Auto Row");
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    setFormData((prev) => ({
      ...prev,
      showCreateServiceRequestRow: !prev.showCreateServiceRequestRow
    }));
  };

  return (
    <div>
      <div className="card" style={{ overflowX: "auto" }}>
        <h3 style={{ textAlign: "center" }}>Service Request Control Sheet</h3>
        <div className="row">
          <div className="col-lg-2">
            <button
              style={{
                width: "100%",
                height: "100%",
                float: "left",
                display: "inline-block",
                backgroundColor: "navy",
                color: "white"
              }}
              onClick={(e) => toggleCreateServiceRequestRow(e)}
            >
              New Service Request
            </button>
          </div>
          <div className="col-lg-2"></div>
          <div className="col-lg-2"></div>
          <div className="col-lg-2"></div>
          <div className="col-lg-2">
            <button
              style={{
                float: "right",
                height: "100%",
                marginLeft: "10px",
                display: "inline-block",
                backgroundColor: "white",
                color: "black",
                borderRadius: "5px"
              }}
              onClick={(_e) => resetTable()}
            >
              <i className="fa fa-refresh" aria-hidden="true"></i>
            </button>
          </div>
          <div className="col-lg-2">
            <form>
              <input
                style={{ width: "70%" }}
                value={formData.searchTerm}
                onChange={handleInputChange}
                type="text"
                name="searchTerm"
              />
              <button
                style={{ width: "30%", backgroundColor: "green", color: "white" }}
                type="submit"
                onClick={(e) => searchTable(e)}
              >
                {" "}
                Go{" "}
              </button>
            </form>
          </div>
        </div>

        <table id="database">
          <thead>
            <tr>
              <th>Client Name</th>
              <th>E-mail</th>
              <th>Phone</th>
              <th>Type</th>
              <th>Notes</th>
              <th>Edit</th>
              <th>Documents</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {formData.showCreateServiceRequestRow ? (
              <CreateServiceRequestRow
                clients={formData.clients}
                agents={formData.agents}
                rerender={() => resetTable()}
                closeRow={() => toggleCreateServiceRequestRow()}
                submitterID={adminUserID}
              />
            ) : null}

            {formData.requests ? (
              <>
                {formData.requests.map((request) => (
                  <RequestItem
                    clients={formData.clients}
                    agents={formData.agents}
                    request={request}
                    key={request._id}
                    complete={() => completeAndRemove()}
                    rerender={() => resetTable()}
                    submitterID={adminUserID}
                  />
                ))}
              </>
            ) : null}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ServiceRequestController;
